<script lang="ts">
  import type { Locale } from './locale';

  import { setContext } from 'svelte';

  import { localisedEndpoint } from '../data';
  import { ACTIONS_CONTEXT, createActions } from './actions';
  import { BUILDERS_CONTEXT, createBuilderContext } from './builders';
  import { CONTEXT_CONTEXT, createContentContext } from './content';
  import { CART_CONTEXT, createCartContext } from './cart';
  import { createLocale } from './locale';

  let ready = false;

  const actions = createActions();
  setContext(ACTIONS_CONTEXT, actions);

  let locale: Locale;

  (async () => {
    locale = await createLocale(actions);
  })();

  $: {
    if (locale && !ready) {
      setContext('locale', locale);
      const endpoint = localisedEndpoint(locale.countryCode);
      setContext(BUILDERS_CONTEXT, createBuilderContext(endpoint));
      setContext(CONTEXT_CONTEXT, createContentContext(endpoint));
      setContext(CART_CONTEXT, createCartContext(endpoint));
      ready = true;
    }
  }
</script>

{#if ready}
  <slot />
{/if}
